import { h, render, Component } from 'preact';

export default class ToolTip extends Component {
  constructor() {
    super();

    this.state = {
      tipShown: false,
    };
  }

  handleClick = () => {
    this.setState({ tipShown: true }, () => {
      setTimeout(() => this.setState({ tipShown: false }), 5000);
    });
  };

  handleHover = (hover) => {
    this.setState({ tipShown: hover });
  };

  render() {
    const tipStyle = { position: 'absolute', zIndex: 10, top: '25px', right: 0 };

    const tip = this.state.tipShown
      ? <span
        dangerouslySetInnerHTML={{ __html: this.props.tip }}
        style={tipStyle}
      />
      : null;

    return (
      <span id="c_tooltip" style={{ position: 'relative' }}>
        <span
          dangerouslySetInnerHTML={{ __html: this.props.button }}
          onClick={this.handleClick}
          onMouseEnter={() => this.handleHover(true)}
          onMouseLeave={() => this.handleHover(false)}
        />
        {tip}
      </span>
    );
  }
}
